module.exports = __webpack_public_path__ + "img/Aleena_Mariyam_Reji.d8ee981c.jpg";